import { Box, TextField, Typography } from "@mui/material";

export default function DataFieldsForm({ fields, onChange, values = {} }) {
  const handleChange = (key, value) => {
    onChange((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {fields.map((field) => (
        <Box key={field.key} display="flex" flexDirection="column" gap={1}>
          <Typography variant="subtitle2" fontWeight={500}>
            {field.label}
            {field.required && (
              <Typography
                component="span"
                color="error"
                sx={{ ml: 0.5, fontSize: "0.9rem" }}
              >
                *
              </Typography>
            )}
          </Typography>

          <TextField
            variant="outlined"
            size="small"
            type={field.type || "text"}
            value={values[field.key] || ""}
            onChange={(e) => handleChange(field.key, e.target.value)}
            required={field.required || false}
            fullWidth
            sx={{
              backgroundColor: "white",
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
        </Box>
      ))}
    </Box>
  );
}
